import { Injectable } from '@angular/core';
import {TimeLimit, TimeLimitSegment} from '@icc/configurator/shared';

@Injectable()
export class TimeLimitRollerShutterDriveService {

    /**
     * Pobiera termin realizacji sterowania rolety.
     *
     * @param {object} roller   Roleta
     * @return {number} Termin realizacji sterowania rolety.
     */
    @TimeLimit({
        shortName: 'rollerShutterDrive',
        data: {
            rollerShutter : 'conf.RollerShutter',
        }
    })
    rollerShutterDriveTimeLimit({timeLimits, rollerShutter}): TimeLimitSegment[] {
        if (rollerShutter == null || !rollerShutter.drive || !rollerShutter.drive.time_limit_id) {
            return null;
        }

        const timeLimitId = rollerShutter.drive.time_limit_id;

        return <TimeLimitSegment[]>[{
            type: 'rollerShutterDrive',
            value: timeLimits[timeLimitId],
            data: {
                id  : rollerShutter.drive.id,
                name: rollerShutter.drive.name,
            }
        }];
    }
}
